<button
  class="flex h-4 w-4 items-center justify-center rounded-full bg-states-white text-center text-primary-blue"
  [ngClass]="[disabledClass()]"
  [disabled]="this.isDisabled()"
  (click)="onButtonClick()"
>
  <svg-icon size="sm" [key]="iconKey()" />
</button>
